var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"modal"}},[(_vm.loading && _vm.show)?_c('div',{style:({backgroundColor : _vm.color}),attrs:{"id":"loading"},on:{"click":_vm.hide}},[_c('img',{attrs:{"src":"/img/loader.svg"}})]):(_vm.show)?_c('div',{style:({backgroundColor : _vm.color}),attrs:{"id":"overlay"},on:{"click":_vm.hide}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }